import { Link } from "react-router-dom";

export default function Team1() {
	return (
		<>
			<div className="tf-widget-team main-content">
				<div className="themeflat-container">
					<div className="team-member">
						<div className="title-box title-small center-title-box">
							<h2
								className="title-section wow fadeInUp animated"
								style={{
									display: "inline-block",
									backgroundColor: "#3a6cb6",
									color: "#ffffff",
									borderRadius: "20px",
									padding: "0.25em 0.5em",
								}}
							>
								OUR TEAM
							</h2>
						</div>
						<div className="row team">
							<div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div
									className="team-item wow fadeInUp animated "
									data-wow-delay="0.3s"
								>
									<div className="team-image">
										<img src="images/antony1.jpeg" alt="Team member" />
										<div className="team-social"></div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">Ben O’Neill</h3>
									<h4 className="job">Founder</h4>
									<h4 className="job">Lead Coach</h4>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div
									className="team-item wow fadeInUp animated "
									data-wow-delay="0.5s"
								>
									<div className="team-image">
										<img
											src="images/aaaaaantonyyyyyyy.jpeg"
											alt="Team member"
										/>
										<div className="team-social"></div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">Anthony Tattersall</h3>
									<h4 className="job">Co-Founder of Accelerate</h4>
									<h4 className="job">Lead Coach</h4>
								</div>
							</div>
							{/* <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div
									className="team-item wow fadeInUp animated "
									data-wow-delay="0.7s"
								>
									<div className="team-image">
										<img src="images/member/team4.jpg" alt="Team member" />
										<div className="team-social">
											<ul>
											</ul>
										</div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">Matthew Brooks									</h3>
									<h4 className="job">Team Leader</h4>
								</div>
							</div> */}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
